import React, { useState } from "react";
import { Text, Button } from "src/components";
import { Dialog, Box, Divider } from "@mui/material";

const DeleteUsersDialog = ({ closeDeleteDialog, onConfirm, selectedUsers }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = (e) => {
        setIsDeleting(true);
        onConfirm(e);
    };
    return (
        <Dialog
            open={true}
            maxWidth="md"
            PaperProps={{
                style: {
                    width: 720,
                    height: "auto",
                    borderRadius: 7,
                    overflow: "auto"
                }
            }}
        >
            <Box sx={{ padding: "65px 0" }}>
                <Text size="2rem" weight="700" align="center" margin="0 0 20px 0">
                    {selectedUsers.length > 1 ? "Delete Selected Clients" : "Delete Selected Client"}
                </Text>
                {selectedUsers.length > 1 ?
                    <Text size="1rem" weight="500" align="center" margin="0">
                        Are you sure you want to delete these selected clients?
                    </Text> :
                    <Text size="1rem" weight="500" align="center" margin="0">
                        Are you sure you want to delete this selected client?
                    </Text>}
                <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                    <ul className="list-disc pl-6 space-y-2">
                        {selectedUsers.map((client) => (
                            <li key={client.uuid} className="text-gray-800">
                                <span style={{ fontWeight: "normal" }}>{`${client.firstName} ${client.lastName}`}</span>
                                <span style={{ fontWeight: "bold" }}>{` ${client.email}`}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </Box>

            <Divider />
            <Box sx={{ padding: "25px" }} style={{ display: "flex", justifyContent: "end" }}>
                <Button
                    onClick={closeDeleteDialog}
                    size="0.875rem"
                    border="1px solid #000"
                    color="#000"
                    width="8.75rem"
                    style={{ borderRadius: "7px", boxShadow: "none" }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleDelete}
                    size="0.875rem"
                    backgroundColor="#ff7171"
                    border="1px solid #ff7171"
                    color="#fff"
                    width="8.75rem"
                    style={{ borderRadius: "7px", boxShadow: "none", marginLeft: "25px", opacity: `${isDeleting && "0.6"}` }}
                    disabled={isDeleting}
                >
                    {isDeleting ? "Deleting..." : "Delete"}
                </Button>
            </Box>
        </Dialog>
    );
};

export default DeleteUsersDialog;